(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9123],{

/***/ 34172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useFullVariantByIdSsr; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_data_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4118);
/* harmony import */ var _utils_helper_product_variant_identifier_to_ids__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16237);
/* harmony import */ var _services_variant_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36430);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var useFullVariantByIdSsr = (0,next_data_hooks__WEBPACK_IMPORTED_MODULE_1__/* .createDataHook */ .Qo)("full-variant-by-id", function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(context) {
        var ref, variantService, variantResponse;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    variantService = new _services_variant_service__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z();
                    _ctx.next = 4;
                    return variantService.getFullVariant((0,_utils_helper_product_variant_identifier_to_ids__WEBPACK_IMPORTED_MODULE_3__/* .productVariantIdentifierToIds */ .Q)(context === null || context === void 0 ? void 0 : (ref = context.params) === null || ref === void 0 ? void 0 : ref.productVariantIdentifier).variantId);
                case 4:
                    variantResponse = _ctx.sent;
                    return _ctx.abrupt("return", variantResponse.data);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(context) {
        return _ref.apply(this, arguments);
    };
}());


/***/ }),

/***/ 10010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useKeywords; }
/* harmony export */ });
/* harmony import */ var _useLanguageIndependentData_hook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64215);

var useKeywords = (0,_useLanguageIndependentData_hook__WEBPACK_IMPORTED_MODULE_0__/* .useLanguageIndependentData */ .p)("keywords");


/***/ }),

/***/ 50167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ useVariantDetailPage; }
/* harmony export */ });
/* harmony import */ var _useLanguageDependentDataSsr_hook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18060);

var useVariantDetailPage = (0,_useLanguageDependentDataSsr_hook__WEBPACK_IMPORTED_MODULE_0__/* .useLanguageDependentDataSSr */ .Y)("variant-detail-page");


/***/ }),

/***/ 10884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _link_link_base_link_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27397);
/* harmony import */ var _breadcrumbs_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86639);
/* harmony import */ var _breadcrumbs_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_breadcrumbs_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var Breadcrumbs = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_breadcrumbs_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["breadcrumbs-wrapper"]),
        children: props.breadcrumbs.map(function(breadcrumb, index, array) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_breadcrumbs_module_scss__WEBPACK_IMPORTED_MODULE_3___default().breadcrumbs),
                children: [
                    index !== 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_breadcrumbs_module_scss__WEBPACK_IMPORTED_MODULE_3___default().separator),
                        children: "/"
                    }) : undefined,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_link_link_base_link_base__WEBPACK_IMPORTED_MODULE_2__/* .LinkBase */ .w, {
                        href: breadcrumb.href,
                        className: "".concat((_breadcrumbs_module_scss__WEBPACK_IMPORTED_MODULE_3___default().link), " ").concat(index === array.length - 1 ? (_breadcrumbs_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["last-link"]) : ""),
                        children: breadcrumb.name ? breadcrumb.name.length > 30 ? "".concat(breadcrumb.name.substring(0, 30), "...") : breadcrumb.name : ""
                    })
                ]
            }, "breadcrumb-".concat(index));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Breadcrumbs);


/***/ }),

/***/ 64350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_multi_carousel_lib_styles_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48318);
/* harmony import */ var react_multi_carousel_lib_styles_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_multi_carousel_lib_styles_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_multi_carousel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86529);
/* harmony import */ var _themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63367);
/* harmony import */ var _themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _carousel_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72132);
/* harmony import */ var _carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_carousel_module_scss__WEBPACK_IMPORTED_MODULE_4__);






var CarouselComponent = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(props.className || "", " ").concat((_carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["carousel-wrapper"]), " ").concat((_carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[props.type]),
        "data-testid": "carousel-component",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_multi_carousel__WEBPACK_IMPORTED_MODULE_3__["default"], {
            additionalTransfrom: 0,
            arrows: props.items && props.items.length > 1,
            autoPlaySpeed: 3000,
            autoPlay: props.items && props.items.length > 1,
            centerMode: false,
            containerClass: "".concat((_carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["carousel-container"])),
            dotListClass: "".concat((_carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["carousel-dots"]), " ").concat((_carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default())["".concat(props.inverted && "inverted")]),
            draggable: props.items && props.items.length > 1,
            focusOnSelect: false,
            infinite: true,
            itemClass: "".concat((_carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["carousel-item"])),
            keyBoardControl: true,
            minimumTouchDrag: 80,
            renderButtonGroupOutside: false,
            renderDotsOutside: true,
            responsive: {
                desktop: {
                    breakpoint: {
                        max: 8192,
                        min: Number(_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_5___default().desktopSmall.slice(0, -2))
                    },
                    items: 1
                },
                mobile: {
                    breakpoint: {
                        max: Number(_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_5___default().mobile.slice(0, -2)),
                        min: 0
                    },
                    items: 1
                },
                tablet: {
                    breakpoint: {
                        max: Number(_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_5___default().desktopSmall.slice(0, -2)),
                        min: Number(_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_5___default().mobile.slice(0, -2))
                    },
                    items: 1
                }
            },
            sliderClass: "".concat((_carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["carousel-sliderClass"])),
            showDots: props.items && props.items.length > 1,
            slidesToSlide: 1,
            swipeable: props.items && props.items.length > 1,
            partialVisible: true,
            children: props.items.map(function(item, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default().item),
                    children: item
                }, index);
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CarouselComponent);


/***/ }),

/***/ 69557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _api_hooks_useGlobal_hook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77459);
/* harmony import */ var _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77872);
/* harmony import */ var _utils_helper_locale_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50325);
/* harmony import */ var _typography_typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28773);
/* harmony import */ var _price_box_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34987);
/* harmony import */ var _price_box_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_price_box_module_scss__WEBPACK_IMPORTED_MODULE_6__);







var PriceBox = function(props) {
    var ref;
    var data = (0,_api_hooks_useGlobal_hook__WEBPACK_IMPORTED_MODULE_2__/* .useGlobal */ .O)();
    var ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_price_box_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["price-box"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_5__/* .Typography */ .Z, {
                className: (_price_box_module_scss__WEBPACK_IMPORTED_MODULE_6___default().price),
                variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .TypographyVariantsEnum.HEADING3_BOLD */ .H.HEADING3_BOLD,
                element: "span",
                children: props.currencies === "FIAT_AND_ETH" ? "".concat((0,_utils_helper_locale_helper__WEBPACK_IMPORTED_MODULE_4__/* .getLocalePrice */ .yb)(props.fiatPrice), "\u20AC") : "".concat((0,_utils_helper_locale_helper__WEBPACK_IMPORTED_MODULE_4__/* .getLocaleEthPrice */ .af)(props.ethPrice), "\u039E")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_5__/* .Typography */ .Z, {
                className: "".concat((_price_box_module_scss__WEBPACK_IMPORTED_MODULE_6___default().price), " ").concat(props.currencies === "ETH" ? (_price_box_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["secondary-price"]) : ""),
                variant: props.currencies === "FIAT_AND_ETH" ? _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .TypographyVariantsEnum.HEADING3_BOLD */ .H.HEADING3_BOLD : _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .TypographyVariantsEnum.HEADING4_LIGHT */ .H.HEADING4_LIGHT,
                element: "span",
                children: props.currencies === "FIAT_AND_ETH" ? "".concat((0,_utils_helper_locale_helper__WEBPACK_IMPORTED_MODULE_4__/* .getLocaleEthPrice */ .af)(props.ethPrice), "\u039E") : "(".concat((0,_utils_helper_locale_helper__WEBPACK_IMPORTED_MODULE_4__/* .getLocalePrice */ .yb)(props.fiatPrice), "\u20AC)")
            }),
            props.withTaxRate ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_5__/* .Typography */ .Z, {
                variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .TypographyVariantsEnum.CAPTION */ .H.CAPTION,
                element: "span",
                children: (ref1 = data === null || data === void 0 ? void 0 : (ref = data.salesBox) === null || ref === void 0 ? void 0 : ref.valueAddedTax) !== null && ref1 !== void 0 ? ref1 : ""
            }) : undefined
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PriceBox);
PriceBox.defaultProps = {
    currencies: "FIAT_AND_ETH"
};


/***/ }),

/***/ 25834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77872);
/* harmony import */ var _typography_typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28773);
/* harmony import */ var _sales_box_footer_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64945);
/* harmony import */ var _sales_box_footer_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_sales_box_footer_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var SalesBoxFooter = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_sales_box_footer_module_scss__WEBPACK_IMPORTED_MODULE_4___default().footer),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .Z, {
                variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_2__/* .TypographyVariantsEnum.CAPTION */ .H.CAPTION,
                className: (_sales_box_footer_module_scss__WEBPACK_IMPORTED_MODULE_4___default().headline),
                element: "span",
                children: props.headline
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .Z, {
                variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_2__/* .TypographyVariantsEnum.CAPTION */ .H.CAPTION,
                element: "span",
                children: props.description
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SalesBoxFooter);


/***/ }),

/***/ 42154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ transaction_fee_box; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/api/hooks/useGlobal.hook.ts
var useGlobal_hook = __webpack_require__(77459);
// EXTERNAL MODULE: ./src/utils/_enums/typeography-variants.enum.tsx
var typeography_variants_enum = __webpack_require__(77872);
// EXTERNAL MODULE: ./src/utils/_helper/locale-helper.tsx
var locale_helper = __webpack_require__(50325);
// EXTERNAL MODULE: ./src/utils/_hooks/hooks.tsx
var hooks = __webpack_require__(62251);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(2593);
// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 2 modules
var lib_esm = __webpack_require__(35553);
// EXTERNAL MODULE: ./src/utils/_helper/isServer.ts
var isServer = __webpack_require__(63755);
;// CONCATENATED MODULE: ./src/utils/_hooks/useEstimateGasFee.hook.ts



var useEstimateGasFee = function(gasUsage, gasPrice) {
    if ((0,isServer/* isServer */.s)()) return 0;
    var ref = (0,react.useState)(0), data = ref[0], setData = ref[1];
    (0,react.useEffect)(function() {
        if (gasPrice) {
            var gasFee = bignumber/* BigNumber.from */.O$.from(gasUsage).mul(bignumber/* BigNumber.from */.O$.from(gasPrice)).toString();
            setData(Number(lib_esm/* formatEther */.dF(gasFee)));
        }
    }, [
        gasPrice
    ]);
    return data;
};
/* harmony default export */ var useEstimateGasFee_hook = (useEstimateGasFee);

// EXTERNAL MODULE: ./src/components/_shared/typography/typography.tsx
var typography = __webpack_require__(28773);
// EXTERNAL MODULE: ./src/components/_shared/sales-box/_shared/transaction-fee-box/transaction-fee-box.module.scss
var transaction_fee_box_module = __webpack_require__(92835);
var transaction_fee_box_module_default = /*#__PURE__*/__webpack_require__.n(transaction_fee_box_module);
;// CONCATENATED MODULE: ./src/components/_shared/sales-box/_shared/transaction-fee-box/transaction-fee-box.tsx









var TransactionFeeBox = function(props) {
    var data = (0,useGlobal_hook/* useGlobal */.O)();
    var ethereumPriceData = (0,hooks/* useAppSelector */.C)(function(state) {
        return state.blockchainSlice.ethereumPriceData;
    });
    var estimatedGasFee = useEstimateGasFee_hook(props.gasUsage, ethereumPriceData === null || ethereumPriceData === void 0 ? void 0 : ethereumPriceData.gasPrice);
    if (ethereumPriceData && estimatedGasFee) {
        var ref;
        var ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (transaction_fee_box_module_default())["transaction-fee-box"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                    variant: typeography_variants_enum/* TypographyVariantsEnum.CAPTION */.H.CAPTION,
                    element: "span",
                    children: (ref1 = data === null || data === void 0 ? void 0 : (ref = data.salesBox) === null || ref === void 0 ? void 0 : ref.transactionFee) !== null && ref1 !== void 0 ? ref1 : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                    variant: typeography_variants_enum/* TypographyVariantsEnum.CAPTION */.H.CAPTION,
                    element: "span",
                    children: "~ ".concat((0,locale_helper/* getLocaleEthPrice */.af)(estimatedGasFee), "\u039E\n                    (").concat((0,locale_helper/* getLocalePrice */.yb)(estimatedGasFee * (1 / ethereumPriceData.exchangeRate)), "\u20AC)")
                })
            ]
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
};
/* harmony default export */ var transaction_fee_box = (TransactionFeeBox);


/***/ }),

/***/ 93659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stage_image_background; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/assets/default_header.jpg
/* harmony default export */ var default_header = ({"src":"/_next/static/media/default_header.e80958d5.jpg","height":775,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAcEAACAgIDAAAAAAAAAAAAAAABAgADBAURE9H/xAAVAQEBAAAAAAAAAAAAAAAAAAADBP/EABYRAAMAAAAAAAAAAAAAAAAAAAABMf/aAAwDAQACEQMRAD8AhbbNutDM60kgqOehPIiJSoE6f//Z"});
// EXTERNAL MODULE: ./src/utils/_hooks/useWindowSize.hook.ts
var useWindowSize_hook = __webpack_require__(29486);
// EXTERNAL MODULE: ./src/components/_shared/stage-image-background/stage-image-background.module.scss
var stage_image_background_module = __webpack_require__(48106);
var stage_image_background_module_default = /*#__PURE__*/__webpack_require__.n(stage_image_background_module);
;// CONCATENATED MODULE: ./src/components/_shared/stage-image-background/stage-image-background.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var StageImageBackground = function(props) {
    var ref = _slicedToArray((0,useWindowSize_hook/* default */.Z)(), 1), width = ref[0];
    var _url;
    return width ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        className: "".concat((stage_image_background_module_default())["stage-background"], " ").concat(props.className ? props.className : ""),
        src: (_url = props.url) !== null && _url !== void 0 ? _url : default_header.src,
        alt: props.alt,
        layout: "fill",
        sizes: width > 1920 ? "100vw" : "1920px",
        objectPosition: props.objectPosition,
        objectFit: "cover",
        priority: true
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
};
/* harmony default export */ var stage_image_background = (StageImageBackground);
StageImageBackground.defaultProps = {
    objectPosition: "top"
};


/***/ }),

/***/ 30815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ teaser_card_profile_picture; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
;// CONCATENATED MODULE: ./src/utils/_helper/build-profile-picture-url.tsx

var buildProfilePictureUrl = function(imageId) {
    var publicRuntimeConfig = (0,config["default"])().publicRuntimeConfig;
    return "".concat(publicRuntimeConfig.backendURL, "api/user-profile/image/").concat(imageId);
};

// EXTERNAL MODULE: ./src/components/_shared/media/media.tsx + 3 modules
var media = __webpack_require__(38925);
// EXTERNAL MODULE: ./src/components/_shared/teaser-card-components/teaser-card-profile-picture/teaser-card-profile-picture.module.scss
var teaser_card_profile_picture_module = __webpack_require__(93577);
var teaser_card_profile_picture_module_default = /*#__PURE__*/__webpack_require__.n(teaser_card_profile_picture_module);
;// CONCATENATED MODULE: ./src/components/_shared/teaser-card-components/teaser-card-profile-picture/teaser-card-profile-picture.tsx





var TeaserCardProfilePicture = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(media/* Media */.pU, {
        className: (teaser_card_profile_picture_module_default())["profile-picture"],
        alt: "profile-picture",
        isProfile: true,
        initialLoad: props.initialLoad,
        src: buildProfilePictureUrl(props.profilePictureId),
        classNameWrapper: (teaser_card_profile_picture_module_default())["profile-picture-wrapper"],
        squared: true
    });
};
/* harmony default export */ var teaser_card_profile_picture = (TeaserCardProfilePicture);


/***/ }),

/***/ 10747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _api_hooks_useFullVariantByIdSsr_hook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34172);
/* harmony import */ var _api_hooks_useVariantDetailPage_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50167);
/* harmony import */ var _utils_enums_link_variants_enum__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11702);
/* harmony import */ var _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77872);
/* harmony import */ var _utils_helper_locale_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50325);
/* harmony import */ var _shared_link_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46164);
/* harmony import */ var _shared_teaser_card_components_teaser_card_profile_picture_teaser_card_profile_picture__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30815);
/* harmony import */ var _shared_typography_typography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28773);
/* harmony import */ var _originator_list_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(55214);
/* harmony import */ var _originator_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_originator_list_module_scss__WEBPACK_IMPORTED_MODULE_10__);











var OriginatorList = function() {
    var data = (0,_api_hooks_useVariantDetailPage_hook__WEBPACK_IMPORTED_MODULE_3__/* .useVariantDetailPage */ .l)();
    var variant = (0,_api_hooks_useFullVariantByIdSsr_hook__WEBPACK_IMPORTED_MODULE_2__/* .useFullVariantByIdSsr */ .Q)();
    var originators = variant === null || variant === void 0 ? void 0 : variant.originators;
    var lang1 = (0,_utils_helper_locale_helper__WEBPACK_IMPORTED_MODULE_6__/* .getLanguage */ .G3)();
    var getLangDependentDescription = function(originator, lang) {
        switch(lang){
            case "de":
                return originator === null || originator === void 0 ? void 0 : originator.detailedDescriptionDe;
            case "es":
                return originator === null || originator === void 0 ? void 0 : originator.detailedDescriptionEs;
            default:
                return originator === null || originator === void 0 ? void 0 : originator.detailedDescription;
        }
    };
    var renderOriginator = function(originator) {
        var ref, _userWebsiteUrl, _userWebsiteUrl1;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_originator_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["originator-box"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_originator_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["author-image-box"]),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_originator_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["author-image"]),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_teaser_card_components_teaser_card_profile_picture_teaser_card_profile_picture__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            profilePictureId: originator.id
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_originator_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["content-box"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_typography_typography__WEBPACK_IMPORTED_MODULE_9__/* .Typography */ .Z, {
                            variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .TypographyVariantsEnum.HEADING5 */ .H.HEADING5,
                            element: "span",
                            children: "".concat(originator.firstName, " ").concat(originator.lastName)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_typography_typography__WEBPACK_IMPORTED_MODULE_9__/* .Typography */ .Z, {
                            className: (_originator_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["originator-description"]),
                            variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .TypographyVariantsEnum.PARAGRAPH */ .H.PARAGRAPH,
                            children: (ref = getLangDependentDescription(originator, lang1)) !== null && ref !== void 0 ? ref : ""
                        }),
                        originator.userWebsiteUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_link_link__WEBPACK_IMPORTED_MODULE_7__/* .Link */ .r, {
                            href: (_userWebsiteUrl = originator.userWebsiteUrl) !== null && _userWebsiteUrl !== void 0 ? _userWebsiteUrl : "",
                            external: true,
                            variant: _utils_enums_link_variants_enum__WEBPACK_IMPORTED_MODULE_4__/* .LinkVariants.STANDARD_LINK */ .C.STANDARD_LINK,
                            className: (_originator_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["originator-link"]),
                            children: (_userWebsiteUrl1 = originator.userWebsiteUrl) !== null && _userWebsiteUrl1 !== void 0 ? _userWebsiteUrl1 : ""
                        }) : null
                    ]
                })
            ]
        }, originator.id);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_originator_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["originator-list"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_typography_typography__WEBPACK_IMPORTED_MODULE_9__/* .Typography */ .Z, {
                variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .TypographyVariantsEnum.HEADING3_BOLD */ .H.HEADING3_BOLD,
                className: (_originator_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["originator-list-headline"]),
                children: data === null || data === void 0 ? void 0 : data.productOriginators.headlineContent
            }),
            originators && originators.map(function(originator) {
                return renderOriginator(originator);
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OriginatorList);


/***/ }),

/***/ 81105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _api_hooks_useFullVariantByIdSsr_hook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34172);
/* harmony import */ var _api_hooks_useVariantDetailPage_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50167);
/* harmony import */ var _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77872);
/* harmony import */ var _utils_helper_locale_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50325);
/* harmony import */ var _shared_typography_typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28773);
/* harmony import */ var _publisher_info_box_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26250);
/* harmony import */ var _publisher_info_box_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_publisher_info_box_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _shared_media_media__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38925);









var PublisherInfoBox = function(props) {
    var data = (0,_api_hooks_useVariantDetailPage_hook__WEBPACK_IMPORTED_MODULE_3__/* .useVariantDetailPage */ .l)();
    var fullVariant = (0,_api_hooks_useFullVariantByIdSsr_hook__WEBPACK_IMPORTED_MODULE_2__/* .useFullVariantByIdSsr */ .Q)();
    var ref = {
        product: fullVariant === null || fullVariant === void 0 ? void 0 : fullVariant.product,
        publisher: fullVariant === null || fullVariant === void 0 ? void 0 : fullVariant.publisher
    }, product = ref.product, publisher = ref.publisher;
    if (product && publisher) {
        var lang = (0,_utils_helper_locale_helper__WEBPACK_IMPORTED_MODULE_5__/* .getLanguage */ .G3)();
        var langDependendDescription = lang === "de" ? publisher === null || publisher === void 0 ? void 0 : publisher.detailedDescriptionDe : publisher === null || publisher === void 0 ? void 0 : publisher.detailedDescription;
        var _className;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_publisher_info_box_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["publisher-info-box"]), " ").concat((_className = props.className) !== null && _className !== void 0 ? _className : ""),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_publisher_info_box_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["publisher-info-box-inner-wrapper"]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_typography_typography__WEBPACK_IMPORTED_MODULE_6__/* .Typography */ .Z, {
                        className: (_publisher_info_box_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headline),
                        variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_4__/* .TypographyVariantsEnum.HEADING3_BOLD */ .H.HEADING3_BOLD,
                        children: data === null || data === void 0 ? void 0 : data.publisherHeadline.headlineContent
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_publisher_info_box_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["lower-wrapper"]),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_publisher_info_box_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["lower-wrapper-left"]),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_typography_typography__WEBPACK_IMPORTED_MODULE_6__/* .Typography */ .Z, {
                                        variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_4__/* .TypographyVariantsEnum.HEADING6 */ .H.HEADING6,
                                        children: publisher.companyName
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_typography_typography__WEBPACK_IMPORTED_MODULE_6__/* .Typography */ .Z, {
                                        variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_4__/* .TypographyVariantsEnum.BODY */ .H.BODY,
                                        className: "".concat((_publisher_info_box_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["publisher-description"]), " ").concat((_publisher_info_box_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["description-body"])),
                                        children: langDependendDescription !== null && langDependendDescription !== void 0 ? langDependendDescription : ""
                                    })
                                ]
                            }),
                            product.publisherImageUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_publisher_info_box_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["lower-wrapper-right"]),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_media_media__WEBPACK_IMPORTED_MODULE_7__/* .Media */ .pU, {
                                    className: (_publisher_info_box_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["publisher-logo"]),
                                    objectFit: "contain",
                                    src: product.publisherImageUrl
                                })
                            })
                        ]
                    })
                ]
            })
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (PublisherInfoBox);


/***/ }),

/***/ 19789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(92565);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67814);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _api_hooks_useFullVariantByIdSsr_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34172);
/* harmony import */ var _api_hooks_useVariantDetailPage_hook__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50167);
/* harmony import */ var _api_models_variant_image_type__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84623);
/* harmony import */ var _utils_enums_link_variants_enum__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11702);
/* harmony import */ var _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77872);
/* harmony import */ var _utils_hooks_useFilterAttachments_hook__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67674);
/* harmony import */ var _shared_link_link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46164);
/* harmony import */ var _shared_typography_typography__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28773);
/* harmony import */ var _legal_box_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(62152);
/* harmony import */ var _legal_box_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_legal_box_module_scss__WEBPACK_IMPORTED_MODULE_11__);













var LegalBox = function() {
    var variant = (0,_api_hooks_useFullVariantByIdSsr_hook__WEBPACK_IMPORTED_MODULE_3__/* .useFullVariantByIdSsr */ .Q)();
    var legals = (0,_utils_hooks_useFilterAttachments_hook__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_api_models_variant_image_type__WEBPACK_IMPORTED_MODULE_5__/* .VariantImageType.SALES_CONDITIONS */ .W.SALES_CONDITIONS, variant === null || variant === void 0 ? void 0 : variant.attachments);
    var data = (0,_api_hooks_useVariantDetailPage_hook__WEBPACK_IMPORTED_MODULE_4__/* .useVariantDetailPage */ .l)();
    if (legals && legals.length > 0) {
        var ref;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_legal_box_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["downloadable-file-box"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_typography_typography__WEBPACK_IMPORTED_MODULE_10__/* .Typography */ .Z, {
                    variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_7__/* .TypographyVariantsEnum.HEADING4_BOLD */ .H.HEADING4_BOLD,
                    className: (_legal_box_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["box-headline"]),
                    children: data === null || data === void 0 ? void 0 : data.legal.headlineContent
                }),
                legals.map(function(file) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_legal_box_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["file-column"]),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                                icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_12__/* .faDownload */ .q7m
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_link_link__WEBPACK_IMPORTED_MODULE_9__/* .Link */ .r, {
                                href: (ref = file === null || file === void 0 ? void 0 : file.url) !== null && ref !== void 0 ? ref : "",
                                className: (_legal_box_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["instance-detail-link"]),
                                variant: _utils_enums_link_variants_enum__WEBPACK_IMPORTED_MODULE_6__/* .LinkVariants.STANDARD_LINK */ .C.STANDARD_LINK,
                                target: "_blank",
                                children: file === null || file === void 0 ? void 0 : file.name
                            })
                        ]
                    }, file.id);
                })
            ]
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (LegalBox);


/***/ }),

/***/ 90869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(92565);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67814);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _api_hooks_useVariantDetailPage_hook__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50167);
/* harmony import */ var _api_models_variant_image_type__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84623);
/* harmony import */ var _utils_config_axios__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79098);
/* harmony import */ var _utils_enums_link_variants_enum__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11702);
/* harmony import */ var _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77872);
/* harmony import */ var _utils_hooks_hooks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62251);
/* harmony import */ var _utils_hooks_useFilterAttachments_hook__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67674);
/* harmony import */ var _shared_link_link__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(46164);
/* harmony import */ var _shared_typography_typography__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(28773);
/* harmony import */ var _product_artifact_box_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(54334);
/* harmony import */ var _product_artifact_box_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_product_artifact_box_module_scss__WEBPACK_IMPORTED_MODULE_13__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}















var ProductArtifactBox = function(props) {
    var attachments = (0,_utils_hooks_hooks__WEBPACK_IMPORTED_MODULE_9__/* .useAppSelector */ .C)(function(state) {
        return state.productSlice.attachments;
    });
    var data = (0,_api_hooks_useVariantDetailPage_hook__WEBPACK_IMPORTED_MODULE_4__/* .useVariantDetailPage */ .l)();
    var productArtifacts = (0,_utils_hooks_useFilterAttachments_hook__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_api_models_variant_image_type__WEBPACK_IMPORTED_MODULE_5__/* .VariantImageType.PRODUCT_ARTIFACT */ .W.PRODUCT_ARTIFACT, attachments);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(undefined), instanceArtifact = ref[0], setInstanceArtifact = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (props.instanceId) {
            _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var res;
                return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return (0,_utils_config_axios__WEBPACK_IMPORTED_MODULE_6__/* .backend */ .y)(true).get("api/perm-attachments?instanceId.equals=".concat(props.instanceId));
                        case 2:
                            res = _ctx.sent;
                            setInstanceArtifact(res.data);
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        }
    }, [
        props.instanceId
    ]);
    if (data) {
        var ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
        var ref9, ref10;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "".concat((_product_artifact_box_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-artifact-box"]), " ").concat((_product_artifact_box_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["downloadable-file-box"])),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_shared_typography_typography__WEBPACK_IMPORTED_MODULE_12__/* .Typography */ .Z, {
                    className: (_product_artifact_box_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-artifact-headline"]),
                    variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_8__/* .TypographyVariantsEnum.HEADING4_BOLD */ .H.HEADING4_BOLD,
                    children: data.product.headlineContent
                }),
                productArtifacts || instanceArtifact ? ((productArtifacts === null || productArtifacts === void 0 ? void 0 : (ref1 = productArtifacts[0]) === null || ref1 === void 0 ? void 0 : ref1.url) || (instanceArtifact === null || instanceArtifact === void 0 ? void 0 : (ref2 = instanceArtifact[0]) === null || ref2 === void 0 ? void 0 : ref2.url)) && props.isOwner ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: (_product_artifact_box_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["file-column"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                            icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_14__/* .faDownload */ .q7m
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_shared_link_link__WEBPACK_IMPORTED_MODULE_11__/* .Link */ .r, {
                            href: (ref9 = instanceArtifact === null || instanceArtifact === void 0 ? void 0 : (ref3 = instanceArtifact[0]) === null || ref3 === void 0 ? void 0 : ref3.url) !== null && ref9 !== void 0 ? ref9 : (ref4 = productArtifacts[0]) === null || ref4 === void 0 ? void 0 : ref4.url,
                            className: (_product_artifact_box_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["instance-detail-link"]),
                            variant: _utils_enums_link_variants_enum__WEBPACK_IMPORTED_MODULE_7__/* .LinkVariants.STANDARD_LINK */ .C.STANDARD_LINK,
                            target: "_blank",
                            children: (ref10 = (instanceArtifact === null || instanceArtifact === void 0 ? void 0 : (ref5 = instanceArtifact[0]) === null || ref5 === void 0 ? void 0 : ref5.url) ? instanceArtifact === null || instanceArtifact === void 0 ? void 0 : (ref6 = instanceArtifact[0]) === null || ref6 === void 0 ? void 0 : ref6.name : (ref7 = productArtifacts[0]) === null || ref7 === void 0 ? void 0 : ref7.name) !== null && ref10 !== void 0 ? ref10 : ""
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: (_product_artifact_box_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-artifact-name"]),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_shared_typography_typography__WEBPACK_IMPORTED_MODULE_12__/* .Typography */ .Z, {
                        variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_8__/* .TypographyVariantsEnum.MOBILENAVLINK */ .H.MOBILENAVLINK,
                        children: (ref8 = productArtifacts[0]) === null || ref8 === void 0 ? void 0 : ref8.name
                    })
                }) : null
            ]
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {});
    }
};
ProductArtifactBox.defaultProps = {
    isOwner: false
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductArtifactBox);


/***/ }),

/***/ 45316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(92565);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67814);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _api_hooks_useFullVariantByIdSsr_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34172);
/* harmony import */ var _api_hooks_useVariantDetailPage_hook__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50167);
/* harmony import */ var _api_models_variant_image_type__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84623);
/* harmony import */ var _utils_enums_link_variants_enum__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11702);
/* harmony import */ var _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77872);
/* harmony import */ var _utils_hooks_useFilterAttachments_hook__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67674);
/* harmony import */ var _shared_link_link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46164);
/* harmony import */ var _shared_typography_typography__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28773);
/* harmony import */ var _sample_box_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17060);
/* harmony import */ var _sample_box_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_sample_box_module_scss__WEBPACK_IMPORTED_MODULE_11__);













var SampleBox = function(props) {
    var variant = (0,_api_hooks_useFullVariantByIdSsr_hook__WEBPACK_IMPORTED_MODULE_3__/* .useFullVariantByIdSsr */ .Q)();
    var data = (0,_api_hooks_useVariantDetailPage_hook__WEBPACK_IMPORTED_MODULE_4__/* .useVariantDetailPage */ .l)();
    var samples = (0,_utils_hooks_useFilterAttachments_hook__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_api_models_variant_image_type__WEBPACK_IMPORTED_MODULE_5__/* .VariantImageType.PRODUCT_SAMPLE */ .W.PRODUCT_SAMPLE, variant === null || variant === void 0 ? void 0 : variant.attachments);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_sample_box_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["downloadable-file-box"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_typography_typography__WEBPACK_IMPORTED_MODULE_10__/* .Typography */ .Z, {
                className: (_sample_box_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["box-headline"]),
                variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_7__/* .TypographyVariantsEnum.HEADING4_BOLD */ .H.HEADING4_BOLD,
                children: data === null || data === void 0 ? void 0 : data.samples.headlineContent
            }),
            samples && samples.length > 0 && (samples === null || samples === void 0 ? void 0 : samples.map(function(sample) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_sample_box_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["file-column"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                            icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_12__/* .faPlayCircle */ .aQp
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_link_link__WEBPACK_IMPORTED_MODULE_9__/* .Link */ .r, {
                            href: "",
                            className: (_sample_box_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["instance-detail-link"]),
                            variant: _utils_enums_link_variants_enum__WEBPACK_IMPORTED_MODULE_6__/* .LinkVariants.STANDARD_LINK */ .C.STANDARD_LINK,
                            onClick: function() {
                                return props.onClick(sample);
                            },
                            disabled: !sample.url || sample.url === "" || !sample.id,
                            children: sample.name
                        })
                    ]
                }, sample.id);
            }))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SampleBox);


/***/ }),

/***/ 41865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _api_hooks_useVariantDetailPage_hook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50167);
/* harmony import */ var _api_models_variant_image_type__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84623);
/* harmony import */ var _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77872);
/* harmony import */ var _utils_hooks_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62251);
/* harmony import */ var _utils_hooks_useFilterAttachments_hook__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67674);
/* harmony import */ var _shared_typography_typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28773);
/* harmony import */ var _unlockables_box_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46786);
/* harmony import */ var _unlockables_box_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_unlockables_box_module_scss__WEBPACK_IMPORTED_MODULE_8__);









var UnlockablesBox = function() {
    var attachments = (0,_utils_hooks_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useAppSelector */ .C)(function(state) {
        return state.productSlice.attachments;
    });
    var data = (0,_api_hooks_useVariantDetailPage_hook__WEBPACK_IMPORTED_MODULE_2__/* .useVariantDetailPage */ .l)();
    var unlockables = (0,_utils_hooks_useFilterAttachments_hook__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_api_models_variant_image_type__WEBPACK_IMPORTED_MODULE_3__/* .VariantImageType.ADDITIONAL_FILES */ .W.ADDITIONAL_FILES, attachments);
    if (data && unlockables && unlockables.length > 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_unlockables_box_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["unlockables-box"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_typography_typography__WEBPACK_IMPORTED_MODULE_7__/* .Typography */ .Z, {
                    variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_4__/* .TypographyVariantsEnum.HEADING4_BOLD */ .H.HEADING4_BOLD,
                    children: data.unlockables.headlineContent
                }),
                unlockables.map(function(item) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_unlockables_box_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["unlockable-item"]),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_typography_typography__WEBPACK_IMPORTED_MODULE_7__/* .Typography */ .Z, {
                                variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_4__/* .TypographyVariantsEnum.MOBILENAVLINK */ .H.MOBILENAVLINK,
                                children: item.name
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_typography_typography__WEBPACK_IMPORTED_MODULE_7__/* .Typography */ .Z, {
                                variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_4__/* .TypographyVariantsEnum.CAPTION */ .H.CAPTION,
                                element: "span",
                                children: item.description
                            })
                        ]
                    }, item.id);
                })
            ]
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (UnlockablesBox);


/***/ }),

/***/ 78300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ VariantDetailStageMetaBoxAudioVideo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92212);
/* harmony import */ var _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77872);
/* harmony import */ var _shared_button_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93217);
/* harmony import */ var _shared_dialog_dialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72807);
/* harmony import */ var _shared_media_media__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(38925);
/* harmony import */ var _shared_typography_typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28773);
/* harmony import */ var _variant_detail_stage_meta_box_audio_video_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48868);
/* harmony import */ var _variant_detail_stage_meta_box_audio_video_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_variant_detail_stage_meta_box_audio_video_module_scss__WEBPACK_IMPORTED_MODULE_8__);









var audioFormats = [
    "mp3",
    "ogg",
    "wav",
    "mpeg"
];
var videoFormats = [
    "mp4"
];
var resolveElementForData = function(type, url, id) {
    var splittedUrl = type.split("/");
    var typeRes = splittedUrl[splittedUrl.length - 1];
    if (audioFormats.includes(typeRes !== null && typeRes !== void 0 ? typeRes : "")) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("audio", {
            controls: true,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                    src: url,
                    type: type
                }),
                "Your browser does not support the audio element."
            ]
        });
    } else if (videoFormats.includes(typeRes !== null && typeRes !== void 0 ? typeRes : "")) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("video", {
            width: "320",
            height: "240",
            controls: true,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                    src: url,
                    type: type
                }),
                "Your browser does not support the video tag."
            ]
        });
    } else if (typeRes.includes("epub")) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_button_button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
            className: (_variant_detail_stage_meta_box_audio_video_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["button-wrapper"]),
            variant: _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_2__/* .ButtonVariantsEnum.PRIMARY */ .l.PRIMARY,
            onClick: function() {
                return window.open("/epub-reader/".concat(id));
            },
            children: "\xd6ffnen"
        });
    } else if (typeRes.includes("pdf")) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_variant_detail_stage_meta_box_audio_video_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["button-wrapper"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_button_button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
                variant: _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_2__/* .ButtonVariantsEnum.PRIMARY */ .l.PRIMARY,
                onClick: function() {
                    return window.open(url);
                },
                children: "\xd6ffnen"
            })
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_variant_detail_stage_meta_box_audio_video_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["image-button-wrapper"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_media_media__WEBPACK_IMPORTED_MODULE_6__/* .Media */ .pU, {
                    className: (_variant_detail_stage_meta_box_audio_video_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["image-sample"]),
                    alt: "",
                    initialLoad: true,
                    src: url
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_variant_detail_stage_meta_box_audio_video_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["button-wrapper"]),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_button_button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
                        variant: _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_2__/* .ButtonVariantsEnum.PRIMARY */ .l.PRIMARY,
                        onClick: function() {
                            return window.open(url);
                        },
                        children: "\xd6ffnen"
                    })
                })
            ]
        });
    }
};
var VariantDetailStageMetaBoxAudioVideo = function(param) {
    var title = param.title, url = param.url, id = param.id, onClose = param.onClose, type = param.type;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_dialog_dialog__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: "sample-dialog-container",
        onClose: onClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_variant_detail_stage_meta_box_audio_video_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["variant-detail-stage-meta-box-audio-video"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_typography_typography__WEBPACK_IMPORTED_MODULE_7__/* .Typography */ .Z, {
                    element: "h3",
                    variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .TypographyVariantsEnum.HEADING5 */ .H.HEADING5,
                    children: title
                }),
                resolveElementForData(type, url, id)
            ]
        })
    });
};


/***/ }),

/***/ 38456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ VariantDetailStageMetaBoxKeywords; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77872);
/* harmony import */ var _shared_typography_typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28773);
/* harmony import */ var _variant_detail_meta_box_keywords_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43609);
/* harmony import */ var _variant_detail_meta_box_keywords_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_variant_detail_meta_box_keywords_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var VariantDetailStageMetaBoxKeywords = function(param) {
    var variant = param.variant, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_variant_detail_meta_box_keywords_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["variant-detail-meta-box-keywords"]), " ").concat((_variant_detail_meta_box_keywords_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[variant]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_typography_typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .Z, {
            variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_2__/* .TypographyVariantsEnum.KEYWORD_TITLE */ .H.KEYWORD_TITLE,
            disableMarkdown: true,
            children: children
        })
    });
};
VariantDetailStageMetaBoxKeywords.defaultProps = {
    variant: "genre"
};


/***/ }),

/***/ 70808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ creatokenPosterUrlResolver; }
/* harmony export */ });
var creatokenPosterUrlResolver = function(variantId) {
    switch(variantId){
        case 361:
            {
                return "https://images.creatokia.com/technical/creatoken/0.jpg";
            }
        case 360:
            {
                return "https://images.creatokia.com/technical/creatoken/1.jpg";
            }
        case 359:
            {
                return "https://images.creatokia.com/technical/creatoken/2.jpg";
            }
        case 358:
            {
                return "https://images.creatokia.com/technical/creatoken/3.jpg";
            }
        case 357:
            {
                return "https://images.creatokia.com/technical/creatoken/4.jpg";
            }
        case 356:
            {
                return "https://images.creatokia.com/technical/creatoken/5.jpg";
            }
        default:
            {
                return "";
            }
    }
};


/***/ }),

/***/ 19239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ generateUrlToUserOan; }
/* harmony export */ });
/* harmony import */ var _enums_route_path_enum__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16837);

var generateUrlToUserOan = function(userName) {
    var url = "";
    url = "".concat(_enums_route_path_enum__WEBPACK_IMPORTED_MODULE_0__/* .RoutePath.MY_OAN */ .h3.MY_OAN, "/").concat(userName ? userName : "");
    return url;
};



/***/ }),

/***/ 16237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ productVariantIdentifierToIds; }
/* harmony export */ });
var productVariantIdentifierToIds = function(queryString) {
    var splits = queryString.split("-");
    return {
        variantId: parseInt(splits[splits.length - 1]),
        productId: parseInt(splits[splits.length - 2])
    };
};


/***/ }),

/***/ 67674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helper_isServer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63755);


var useFilterAttachments = function(type, attachments) {
    if ((0,_helper_isServer__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .s)()) return [];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), data = ref[0], setData = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (attachments) {
            setData(attachments.filter(function(attachment) {
                return attachment.type === type;
            }));
        }
        return function() {
            setData([]);
        };
    }, [
        attachments
    ]);
    return data;
};
/* harmony default export */ __webpack_exports__["Z"] = (useFilterAttachments);


/***/ }),

/***/ 31416:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var useFilterAttachmentsSsr = function(type, attachments) {
    var ref;
    var ref1;
    return (ref1 = attachments === null || attachments === void 0 ? void 0 : (ref = attachments.filter) === null || ref === void 0 ? void 0 : ref.call(attachments, function(attachment) {
        return attachment.type === type;
    })) !== null && ref1 !== void 0 ? ref1 : [];
};
/* harmony default export */ __webpack_exports__["Z"] = (useFilterAttachmentsSsr);


/***/ }),

/***/ 86639:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs-wrapper":"breadcrumbs_breadcrumbs-wrapper__Z1Mqz","breadcrumbs":"breadcrumbs_breadcrumbs__QX0g9","link":"breadcrumbs_link__jAE8c","last-link":"breadcrumbs_last-link__bHiWy","separator":"breadcrumbs_separator__B0A2_"};

/***/ }),

/***/ 72132:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","carousel-wrapper":"carousel_carousel-wrapper__e12pG","carousel-dots":"carousel_carousel-dots__d3_l5","inverted":"carousel_inverted__hvPWZ","basic-card-horizontal-small":"carousel_basic-card-horizontal-small__e7J_d","carousel-container":"carousel_carousel-container__rfEte","carousel-item":"carousel_carousel-item__Hr4h4","variant-detail":"carousel_variant-detail__XigTv"};

/***/ }),

/***/ 34987:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","price-box":"price-box_price-box__vnNJX","price":"price-box_price__gCGT7","secondary-price":"price-box_secondary-price__ZCShG"};

/***/ }),

/***/ 64945:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","footer":"sales-box-footer_footer__JCSdT","headline":"sales-box-footer_headline__ZoEL3"};

/***/ }),

/***/ 92835:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"transaction-fee-box":"transaction-fee-box_transaction-fee-box__GKAMG"};

/***/ }),

/***/ 48106:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"stage-background":"stage-image-background_stage-background__OC_4p"};

/***/ }),

/***/ 93577:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","profile-picture-wrapper":"teaser-card-profile-picture_profile-picture-wrapper__DSotm","profile-picture":"teaser-card-profile-picture_profile-picture__QOpxe"};

/***/ }),

/***/ 55214:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","originator-list":"originator-list_originator-list__H1XLY","originator-list-headline":"originator-list_originator-list-headline__n_Prp","originator-box":"originator-list_originator-box__3ElE5","author-image":"originator-list_author-image__6_16_","originator-description":"originator-list_originator-description__0F2rF","originator-link":"originator-list_originator-link__pkQf0"};

/***/ }),

/***/ 26250:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","publisher-info-box":"publisher-info-box_publisher-info-box__siqE1","publisher-info-box-inner-wrapper":"publisher-info-box_publisher-info-box-inner-wrapper__nCt5N","headline":"publisher-info-box_headline__F6nxe","description-body":"publisher-info-box_description-body___iE8s","lower-wrapper":"publisher-info-box_lower-wrapper__jiVoH","lower-wrapper-left":"publisher-info-box_lower-wrapper-left__2q_fS","lower-wrapper-right":"publisher-info-box_lower-wrapper-right__UlcJw","publisher-description":"publisher-info-box_publisher-description__jV2XW","publisher-logo":"publisher-info-box_publisher-logo__snupw"};

/***/ }),

/***/ 62152:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","downloadable-file-box":"legal-box_downloadable-file-box__3nomp","box-headline":"legal-box_box-headline__wI_Oc","file-column":"legal-box_file-column__p_Y96","instance-detail-link":"legal-box_instance-detail-link__W_SV1"};

/***/ }),

/***/ 54334:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","product-artifact-box":"product-artifact-box_product-artifact-box__Lg2bz","product-artifact-headline":"product-artifact-box_product-artifact-headline__d_TQU","product-artifact-name":"product-artifact-box_product-artifact-name__Yf3hy","downloadable-file-box":"product-artifact-box_downloadable-file-box__CydSl","box-headline":"product-artifact-box_box-headline__fj4ZL","file-column":"product-artifact-box_file-column__rG6tD","instance-detail-link":"product-artifact-box_instance-detail-link__skBil"};

/***/ }),

/***/ 17060:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","downloadable-file-box":"sample-box_downloadable-file-box__FojX8","box-headline":"sample-box_box-headline__PlJkr","file-column":"sample-box_file-column__9uH3d","instance-detail-link":"sample-box_instance-detail-link__sMxdp"};

/***/ }),

/***/ 46786:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"unlockables-box":"unlockables-box_unlockables-box__jJzrf","unlockable-item":"unlockables-box_unlockable-item__tsVUB","unlockable-content":"unlockables-box_unlockable-content__UndBX"};

/***/ }),

/***/ 48868:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","variant-detail-stage-meta-box-audio-video":"variant-detail-stage-meta-box-audio-video_variant-detail-stage-meta-box-audio-video__eWGWa","variant-detail-stage-meta-box-audio-video-close-button":"variant-detail-stage-meta-box-audio-video_variant-detail-stage-meta-box-audio-video-close-button__lJlPc","button-wrapper":"variant-detail-stage-meta-box-audio-video_button-wrapper__N2rdF","image-button-wrapper":"variant-detail-stage-meta-box-audio-video_image-button-wrapper__tBOM2","image-sample":"variant-detail-stage-meta-box-audio-video_image-sample__Wc81C"};

/***/ }),

/***/ 43609:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","variant-detail-meta-box-keywords":"variant-detail-meta-box-keywords_variant-detail-meta-box-keywords__JTNEY","genre":"variant-detail-meta-box-keywords_genre__vbOtD","keyword":"variant-detail-meta-box-keywords_keyword__6yj1G"};

/***/ })

}]);